export default{ 
    tiposIngredientes: [
        {value:"carboidrato", label:"Carboidrato"},
        {value:"proteina", label:"Proteína"},
        {value:"verdura", label:"Verdura"},
        {value:"legume", label:"Legume"},
        {value:"fruta", label:"Fruta"},
        {value:"tempero", label:"Tempero"}
    ]
}